import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import noNotifications from 'assets/images/no-notifications.png'

export const NoViewers = () => {
    const { t } = useTranslation()

    return (
        <Container>
            <img src={noNotifications} alt='noViewers' />
            <TextWrapper>
                <Title>{t('noViewers')}</Title>
                <Description>{t('noViewersDescription')}</Description>
            </TextWrapper>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 6rem 0 6.2rem 0;
`

const TextWrapper = styled.div`
    text-align: center;
`

const Title = styled.div`
    color: #cfd0da;
    text-align: center;
    letter-spacing: 0.48px;
    font-size: 2.4rem;
    font-weight: 600;
`

const Description = styled.div`
    color: #cfd0da;
    text-align: center;
    letter-spacing: 0.28px;
    font-size: 1.4rem;
`
